import { minValue, required } from "@src/utils/forms/validators";
import type { NumberModel } from "@src/utils/models";
import { FieldState, FormState } from "formstate";

export class BudgetForm {
  id?: string;
  title: FieldState<string>;
  total_budget: FieldState<NumberModel>;
  credit: number;

  _form: FormState<FieldState<any>[]>;

  constructor(args: {
    id?: string;
    title?: string;
    total_budget: NumberModel;
    credit?: number;
  }) {
    this.id = args.id;
    this.title = new FieldState(args.title ?? "").validators(required);
    this.total_budget = new FieldState(args.total_budget).validators(
      minValue(0),
    );
    this.credit = args.credit ?? 0;

    this._form = new FormState([this.title, this.total_budget]);
  }

  protected serialize() {
    return {
      id: this.id,
      title: this.title.value,
      total_budget: this.total_budget.value.denominatedValue,
    };
  }
}
